import type { SiteInventoryHealth } from '@restDataAccess';

import { type TrafficLightType } from '@scaleaq/scaleui';

import { ALL_SITE_SERVICES, SITE_INVENTORY_SERVICES } from '@/constants';
import type { SiteServiceSupport } from '@/hooks';
import { type SiteWithApis } from '@/stores';
import { localeBaseCompare } from '@/utils';

import { SiteCardItem } from './selectSiteModal/siteCardsGroup/siteCardsGroup.types.ts';

type ToSiteCardItemsProps = {
  selectedSiteId?: string;
  siteServiceSupport: SiteServiceSupport;
  sites: SiteWithApis[];
};

export const toSiteCardItems = ({
  selectedSiteId,
  siteServiceSupport,
  sites,
}: ToSiteCardItemsProps): SiteCardItem[] =>
  [...sites]
    .sort((a, b) => localeBaseCompare(a.name, b.name))
    .map(site => ({
      supportedServices: ALL_SITE_SERVICES.filter(service => {
        const definition = SITE_INVENTORY_SERVICES[service];
        return (
          (!('showOnSiteCards' in definition) || definition.showOnSiteCards !== false) &&
          siteServiceSupport[service].siteIds.has(site.id)
        );
      }),
      selected: site.id === selectedSiteId,
      site,
    }));

export const siteInventoryHealthToTrafficLightType = (
  health: SiteInventoryHealth
): TrafficLightType => (health === 'healthy' ? 'success' : 'alarm');
